<template>
   <div class="layout-page">
      <h1>Appointments</h1>
      <div class="alert alert-danger alert-dismissible mart-12" v-if="missingEmailTemplate">
         <button type="button" class="close" data-dismiss="alert">&times;</button>
         <i class="fas fa-exclamation-triangle padr-12"></i>
         You do not currently have an email template defined for automating invites. <router-link to="corr">[Click Here]
         </router-link> to quickly create one.
      </div>
      <p class="mart-12">
         The following are appointments you can use to invite new agents<span v-if="isLoginUserAsRecruiter"> into your
            downline.</span><span v-else> on behalf of the agent below:</span>
      </p>
      <div class="recruiter-box marb-24">
         <div>Agent Number: {{ s.agentNo }} ({{ s.companyNo }}/{{ s.blockNo }})</div>
         <div>{{ recruiter.businessName == null || recruiter.businessName.trim() == '' ? recruiter.name :
            recruiter.businessName }}</div>
         <div>{{ recruiter.address1 }}</div>
         <div v-if="recruiter.address2 != ''">{{ recruiter.address2 }}</div>
         <div v-if="recruiter.city != '' && recruiter.city != null">{{ recruiter.city }},
            {{ recruiter.stateCode }}&nbsp;&nbsp;{{ recruiter.zipCode }}</div>
         <div>{{ recruiter.phone | phone }}</div>
      </div>

      <p class="mart-12">
         There are different ways to create an invitation:
      </p>

      <ul class="instr">
         <li>You can find appointments under each of your agent numbers and add them to your "cart" (<i
               class="fas fa-cart-plus"></i>). Then you can
            send all of the appointments in your "cart" as one link (one application) to your prospect using the "Begin
            Appointment" button below.</li>
         <li>Or you can resend a previous invitation when viewing <router-link to="invites">past invitations
            </router-link>.</li>
      </ul>

      <i class="fas fa-spinner fa-spin ml-orange fa-lg" v-if="loading"></i>
      <div v-else class="marb-24 container-fluid">
         <h3 class="mart-24">Appointments by Commission Schedule</h3>

         <div class="row mart-24">
            <div class="col">
               <hier-ddl :hierarchies="hierarchies" :selectedHierarchy="selectedHierarchy"
                  @hier-changed="hierarchyChanged"></hier-ddl>
            </div>
         </div>

         <div v-if="schedules.length == 0" class="text-danger mart-24">
            No links available...
         </div>
         <div v-else>
            <div class="b-card" v-for="(s, index) in schedules" :key="index">
               <div class="card-header bg-transparent">
                  <i class="fi-ecommerce-dollar-symbol-4 padr-12"></i>
                  <span class="card-label">{{ s.scheduleName }}</span>
               </div>
               <div class="card-body">
                  <table class="table table-condensed">
                     <thead>
                        <tr>
                           <th>Level</th>
                           <th class="text-center">Add to Cart</th>
                           <th>Appointment</th>
                           <th>Commission Schedule Document</th>
                        </tr>
                     </thead>
                     <tbody>
                        <tr v-if="!s.links.length">
                           <td class="ml-red">No levels available. Please edit the schedule.</td>
                        </tr>
                        <tr v-for="r in s.links" :key="r.appointmentLinkId">
                           <td>{{ r.schedRec.levelNo }}</td>
                           <td class="text-center">
                              <a class="btn ml-corp btn-add" @click.prevent="addToCart(r, s, $event)">
                                 <i class="fas fa-cart-plus fa-1x"></i>
                              </a>
                           </td>
                           <td>{{ r.schedRec.levelName }}</td>
                           <td><a href="#" class="doc-link"
                                 @click.prevent="openDoc(r.schedRec.extDocumentId)">{{ cleanDoc(r.schedRec.extDocumentId) }}</a>
                           </td>
                        </tr>
                     </tbody>
                  </table>
               </div>
            </div>
         </div>
         <div class="text-right" v-if="schedules.length > 0">
            <button class="btn ml-bk-white ml-purple ml-h-orange clr-btn-border" @click.prevent="clear">
               <i class="fas fa-minus-circle"></i>
               CLEAR CART
            </button>
            &nbsp;
            <button type="button" class="btn ml-bk-purple ml-white ml-h-black snc-btn" @click.prevent="sendMulti">
               <i class="fas fa-shopping-cart"></i>
               BEGIN APPOINTMENT
               <span class="badge badge-dark">{{ cartCount }}</span>
            </button>
         </div>
      </div>

      <div id="divToast" class="toast" data-delay="2000" style="position: absolute;">
         <div class="toast-header font-weight-bold">
            Added to Cart
         </div>
         <div class="toast-body">
            <span v-if="cartAddCount == 1">
               The level you clicked was ADDED to the cart.
            </span>
            <span v-else>
               {{ cartAddCount }} appointments were ADDED to the cart<br />for various Manhattan Companies.
            </span>
         </div>
      </div>

      <div class="modal fade" id="cartModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
         aria-hidden="true">
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">
                     <i class="fas fa-user-edit"></i>
                     Appointment Links
                  </h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                     <span aria-hidden="true">&times;</span>
                  </button>
               </div>
               <div class="modal-body">
                  <p class="ml-corp">
                     Your cart has these appointments in it:
                  </p>

                  <ul class="link-list">
                     <li class="ml-purple" v-for="(itm, indx) in $store.getters.cart" :key="indx">
                        <i class="fas fa-user-edit"></i>
                        {{ itm.carrierCode }},
                        {{ itm.productType }},
                        {{ itm.mgaCode }},
                        Level {{ itm.schedRec.levelNo }},
                        <span class="ml-black">{{ itm.schedRec.levelName }}</span>
                     </li>
                  </ul>

                  <p>
                     I would like to ...
                  </p>
                  <div class="custom-control custom-radio font-smaller padb-12">
                     <input class="custom-control-input" type="radio" name="actionChoice" id="actionChoiceSend" checked
                        value="SEND" v-model="cartAction">
                     <label class="custom-control-label" for="actionChoiceSend">
                        Send these links to my prospect
                     </label>
                  </div>
                  <div class="custom-control custom-radio font-smaller padb-12">
                     <input class="custom-control-input" type="radio" name="actionChoice" id="actionChoiceApply"
                        value="APPLY" v-model="cartAction">
                     <label class="custom-control-label" for="actionChoiceApply">
                        Fill out the application on my prospect's behalf
                     </label>
                  </div>
                  <div v-if="cartAction == 'APPLY'">
                     <div class="form-group">
                        <label for="email">Type of Appointment:</label>
                        <select v-model="dlgApptType" class="form-control">
                           <option :value="aptInd" v-if="cartIsRep != true">Individual</option>
                           <option :value="aptCorp" v-if="cartIsRep != true">Corporation</option>
                           <option :value="aptRep" v-if="cartIsRep == true">Representative</option>
                        </select>
                     </div>
                     <div class="form-group">
                        <label for="email">Prospect Email address:</label>
                        <p class="font-smaller">
                           This email address will not be contacted during the appointment process.
                           It will only be used as a placeholder until an appointed person decides
                           they want access to EasyAppoint (for recruiting or to review their appointment).
                        </p>
                        <input type="email" class="form-control" placeholder="Enter email" v-model="dlgEmail">
                     </div>
                  </div>
               </div>
               <div class="modal-footer">
                  <button type="button" class="btn ml-bk-black ml-white ml-h-orange btnw"
                     @click.prevent="cartCancelClicked">
                     <i class="fas fa-times"></i>
                     CANCEL
                  </button>
                  <button type="button" class="btn ml-bk-corp ml-white ml-h-black btnw" @click.prevent="cartOkClicked">
                     <i class="fas fa-check"></i>
                     OK
                  </button>
               </div>
            </div>
         </div>
      </div>

   </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from "vuex";
import agtnumDDL from "@/components/agentnumDDL.vue"
import $ from 'jquery'

export default {
   name: "ApptLinksPage",
   components: {
      'hier-ddl': agtnumDDL
   },
   data() {
      return {
         isLoginUserAsRecruiter: false,
         missingEmailTemplate: false,  //TODO
         hierarchies: [],
         selectedHierarchy: null,
         loading: true,
         schedules: [],
         recruiter: {},
         s: {},
         dlgLevelNumber: 0,
         dlgLevelName: '',
         dlgLink: '',
         dlgEmail: '',
         dlgApptType: '',
         scheds: {},
         cartCount: 0,
         cartAction: 'SEND',
         cartIsRep: false,
         cartAddCount: 0,
         agentNumbers: [],
         aptInd: "",
         aptCorp: "",
         aptRep: ""
      }
      },
      computed: {
         ...mapGetters(["isVBInvitation"])
      }, 
      async mounted() {
      this.$parent.loadingStart()
      this.loading = true;

      let last = localStorage.getItem('last-acb')
      if (last && this.$route.params.useLocalStorage != false) {
         let la = JSON.parse(last)
         this.s.agentNo = la.agentNo
         this.s.companyNo = la.companyNo
         this.s.blockNo = la.blockNo

         await this.getHierarchiesFromAcb()

      } else {
         if (this.$route.params.agentNumber == undefined || this.$route.params.agentNumber == null || this.$route.params.agentNumber == "") {
            //Login User's hierarchies         
            this.isLoginUserAsRecruiter = true
            this.hierarchies = this.$store.getters.hierarchies
            if (!this.hierarchies || this.hierarchies.length < 1) {
               await this.$store.dispatch("getHierarchies")
               this.hierarchies = this.$store.getters.hierarchies
            }
            if (this.hierarchies && this.hierarchies.length > 0) {
               this.selectedHierarchy = this.hierarchies[0]
               this.s.agentNo = this.selectedHierarchy.agentNo
               this.s.companyNo = this.selectedHierarchy.companyNo
               this.s.blockNo = this.selectedHierarchy.blockNo
               await this.loadLinks()
            }
            this.agentNumbers = [...new Set(this.hierarchies.map(x => x.agentNo))]
         } else {
            //Passing in agentNo, companyNo and blockNo from agents's hierarchy page/previous page.
            this.isLoginUserAsRecruiter = false

            this.s.agentNo = this.$route.params.agentNumber
            this.s.companyNo = this.$route.params.companyNumber
            this.s.blockNo = this.$route.params.blockNumber

            await this.getHierarchiesFromAcb()
            this.agentNumbers = [...new Set(this.hierarchies.map(x => x.agentNo))]
         }
      }

      //Store the current values to localStorage
      let lastAcb = {
         agentNo: this.s.agentNo,
         companyNo: this.s.companyNo,
         blockNo: this.s.blockNo
      }
      localStorage.setItem('last-acb', JSON.stringify(lastAcb))

      this.loading = false;
      if (this.isVBInvitation) {
         this.aptInd = 'APPTTYP_WVB';
         this.aptCorp = 'APPTTYP_VB_CORP';
      }
      else {
         this.aptInd = 'APPTTYP_IND';
         this.aptCorp = 'APPTTYP_CORP';
         this.aptRep = "APPTTYP_REP";
      }
      this.cartCount = this.$store.getters.cartCount
      this.$parent.loadingEnd()
   },
   methods: {
      async getHierarchiesFromAcb() {
         //Load hierarchy using Agent Number, Block and Company
         let payload = {
            agentNumber: this.s.agentNo,
            blockNumber: this.s.blockNo,
            companyNumber: this.s.companyNo
         }

         return await this.$agent.getHierarchiesFromAcb(payload)
            .then(async r => {
               if (r && r.hierarchyItems.length > 0) {
                  this.hierarchies = r.hierarchyItems
                  var i = 0
                  this.hierarchies.forEach((e, index) => {
                     if (e.agentNo == this.s.agentNo
                        && e.blockNo == this.s.blockNo
                        && e.companyNo == this.s.companyNo) {
                        //Store the index when agent Number, block Number and Company Number are matched.
                        i = index
                     }
                  });
                  this.selectedHierarchy = this.hierarchies[i]

                  if (this.hierarchies != null && this.hierarchies.length > 0) {
                     //No links should be loaded when no Hierachy loaded. 
                     await this.loadLinks()
                     this.clear()
                  } else {
                     this.$swal(
                        "Links Not Found",
                        "No enabled links were found for your current hierarchy. If you think you've reached this impass in error, please contact "+process.env.VUE_APP_MKT_EMAIL+".",
                        "warning"
                     );
                  }
               } else {
                  this.$swal(
                     "Links Not Found",
                     "No enabled links were found for your current hierarchy. If you think you've reached this impass in error, please contact "+process.env.VUE_APP_MKT_EMAIL+".",
                     "warning"
                  );
               }

            })
            .catch(err => {
               this.$swal(
                  "Oops!",
                  "An error occured retrieving Hierarchies control. Please contact support if the problem persists.",
                  "error"
               )
            })
      },

      validateEmail(email) {
         const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
         return re.test(String(email).toLowerCase());
      },
      buildLink(rec) {
         var url = process.env.VUE_APP_URL + '/' + rec.linkRec.link
         return url
      },
      cancelPressed() {
         this.loading = false
         $('#apptModal').modal('hide')
      },
      async newApptPressed() {
         if (this.dlgApptType == '') {
            this.$swal(
               "Appointment Type?",
               "The appointment type is required for creating a new appointment.",
               "error"
            )
            return
         }
         if (this.dlgEmail == '') {
            this.$swal(
               "Prospect Email Required",
               "The email address is required for creating a new appointment.",
               "error"
            )
            return
         }
         if (!this.validateEmail(this.dlgEmail)) {
            this.$swal(
               "Email Address Format Is Invalid",
               "A valid email address is required.",
               "error"
            )
            return
         }

         var username = this.$store.getters.appUser.userName
         if (username != "" && username.toLowerCase() == this.dlgEmail.toLowerCase()) {
            this.$swal(
               "You Cannot Use Your Email",
               "A different email address is required.",
               "error"
            )
            return
         }

         let linx = []
         this.$store.getters.cart.forEach((itm) => {
            linx.push(itm.linkRec.link)
         })
         await this.createMultipleInvite(linx)
      },
      copyToClipboard(text) {
         // The OLD way if needed
         if (!navigator.clipboard) {
            var input = document.body.appendChild(document.createElement("input"));
            input.value = text;
            input.focus();
            input.select();
            document.execCommand('copy');
            input.parentNode.removeChild(input);
            this.$swal(
               "Copied!",
               "Your link was copied to the clipboard.<br />Use Ctrl-V or Command-V to paste...",
               "success"
            );
            // The NEW WAY to copy...
         } else {
            navigator.clipboard.writeText(text).then(() => {
               this.$swal(
                  "Copied!",
                  "Your link was copied to the clipboard.<br />Use Ctrl-V or Command-V to paste...",
                  "success"
               );
            })
               .catch(() => {
                  this.$swal(
                     "Copied!",
                     "Your link was copied to the clipboard.<br />Use Ctrl-V or Command-V to paste...",
                     "success"
                  );
               });
         }
      },
      // Invite to SINGLE appointment
      invite(rec) {
         this.$router.push({ name: 'invite', params: { link: rec, recruiter: this.recruiter, req: this.requester } })
      },
      // Invite to MULTIPLE appointments
      sendMulti() {
         if (this.cartCount < 1) {
            this.$swal(
               "No Links in your Cart",
               "You must add links to your cart by clicking the icons in the 'Add to Cart' column before you can send them to your prospect.",
               "warning"
            );
            return
         }

         this.cartAction = 'SEND'
         $('#cartModal').modal('show')
      },
      async cartOkClicked() {
         let linx = this.$store.getters.cart
         switch (this.cartAction) {
            case 'SEND':
               this.$store.commit("clearCart")
               this.cartCount = this.$store.getters.cartCount
               this.$router.push({ name: 'invite', params: { links: linx, recruiter: this.recruiter, req: this.requester } })
               $('#cartModal').modal('hide')
               break;
            case 'APPLY':
               await this.newApptPressed()
               break;
            default:
               this.$swal(
                  "Please Choose",
                  "You must choose a course of action before continuing.",
                  "error"
               )
               return
         }
      },
      cartCancelClicked() {
         $('#cartModal').modal('hide')
      },
      schedName(ext, inr) {
         if (ext != null && ext != '') return ext
         return inr
      },
      async createMultipleInvite(linx) {
         // We need to create and return the new MultiLinkId
         let payload = { //CreateMultiRequestDTO
            appointmentLinks: linx,
            createdById: this.$store.getters.appUser.userId.toUpperCase()
         }

         await this.$appoint.createMulti(payload)
            .then(async (resp) => {
               if (!resp) {
                  this.$swal(
                     "System Error",
                     "Oops! Some unforseen system error occurred while trying to create the application. Please try again later. If this problem persists please contact support.",
                     "error"
                  );
               }

               //validate whether the email that the user provide is existing in EasyAppoint or not.  
               let payload = {
                  link: resp.multiLink,
                  emailAddress: this.dlgEmail,
                  apptTypeCode: this.dlgApptType
               }

               await this.$appoint.validateAppointmentAndLink(payload)
                  .then(async (r) => {
                     if (r == null) {
                        this.$swal(
                           "System Error",
                           "Oops! Some unforseen system error occurred while trying to validating appointment information. Please try again later. If this problem persists, please contact support.",
                           "error"
                        )
                        return
                     } else {
                        if (r.result == true && r.failureReasonCode == null) {
                           // All is good
                           await this.$appoint.getMultiLink(resp.multiLink)
                              .then(rg => {
                                 if (rg) {
                                    this.$store.commit("clearCart")
                                    this.cartCount = this.$store.getters.cartCount
                                    $('#cartModal').modal('hide')

                                    let payload = {
                                       multiPaper: true,
                                       link: resp.multiLink,
                                       multiLinkId: rg.multiLinkId,
                                       multiLinks: rg.multiLinks,
                                       email: this.dlgEmail,
                                       apptTypeCode: this.dlgApptType,
                                       submitterId: this.$store.getters.appUser.userId
                                    }
                                    this.$router.push({ name: 'appoint', params: payload })
                                 }
                              })
                        } else {
                           if (r.result == false && r.failureReasonCode != null) {
                              let msg = ""
                              switch (r.failureReasonCode) {
                                 case 'BAD_APPT_LINK':
                                    msg = "Bad appointment link.  If this problem persists, please contact support."
                                    break
                                 case 'AGENT_CANNOT_BE_IN_SAME_SCHEDULE_TWICE':
                                    msg = "An appointment app already exists for this email and hierarchy. A different prospect email address is required."
                                    break
                                 default:
                                    msg = "Some unforseen system error.  It should never happen."
                                    break
                              }
                              this.$swal(
                                 "Cannot Create Appointment",
                                 msg,
                                 "warning"
                              )
                              return;
                           }
                        }
                     }

                  })
                  .catch((err) => {
                     this.$swal(
                        "System Error",
                        "Oops! Some unforseen system error occurred while trying to validating appointment information. Please try again later. If this problem persists please contact support.",
                        "error"
                     )
                     return

                  })
            })
            .catch(err => {
               this.$swal(
                  "System Error",
                  "Oops! Some unforseen system error occurred while trying to create the application. Please try again later. If this problem persists please contact support.",
                  "error"
               );
            })
      },
      cleanDoc(pth) {
         if (!pth || pth.length < 1) return;
         let pos = pth.indexOf('\\');
         return pth.substr(pos + 1) // cut off the folder name in front
      },
      async openDoc(doc) {
         let payload = {
            AppUserId: this.$store.getters.appUser.userId,
            DownloadFileType: 1, // ScheduleDoc
            Path: doc,
            Title: this.cleanDoc(doc)
         }

         this.$swal({
            title: 'Download Initiated',
            html: 'Please wait...',
            timer: 1000,
            timerProgressBar: true,
            showCancelButton: false,
            showConfirmButton: false,
            willOpen: () => { this.$swal.showLoading() },
            willClose: () => { }
         })

         this.$appoint.apiDownload(payload).then(r => {
            if (this.$appoint.errors.length > 0) {
               this.$swal(
                  "Document Unavailable",
                  "Unfortunately we are having trouble downloading your document at this time. Please try again later or contact us if this problem persists.",
                  "error"
               );
            } 
         }, e => {
            this.$swal(
               "Document Unavailable",
               "Unfortunately we are having trouble downloading your document at this time. Please try again later or contact us if this problem persists.",
               "error"
            );
         })
      },
      async addToCart(item, sked, e) {

         // Build a cart item
         let cartItem = JSON.parse(JSON.stringify(item))
         cartItem.scheduleId = sked.scheduleId
         cartItem.carrierId = sked.carrierId
         cartItem.carrierCode = sked.carrierCode
         cartItem.mgaCode = sked.mgaCode
         cartItem.productTypeId = sked.header.productTypeId
         cartItem.productType = sked.header.productType
         cartItem.isRep = false

         let baseTypeId = null
         if (sked.header.isBase) {
            baseTypeId = sked.schedHeaderId
         }

         // validate selected item 
         // - only one link can be chosen from each schedule
         // - chosen links must be of the same type (rep vs non-rep)
         let linx = this.$store.getters.cart
         let hid = sked.scheduleId
         let ele = e.target

         let isRep = null  // for the link they are wanting to add
         this.cartIsRep = false
         let wasRep = null // for links already in cart
         let failed = false

         linx.forEach((itm, indx) => {
            if (itm.scheduleId == hid) {

               //only show the error if the agent numbers on the links are the same
               if(item.linkRec.recruiterAgentNumber == itm.linkRec.recruiterAgentNumber)
               {
                  this.$swal(
                     "Schedule Already Chosen",
                     "A link for this commission schedule has already been added to your cart. Only one link from each commissions schedule may be chosen.",
                     "warning"
                  );
                  failed = true
                  return
               }
            }
            wasRep = itm.isRep
         })

         // Determine if the link they want to add is for a REP
         isRep = item.schedRec.enrollRep

         if (wasRep != null && isRep != wasRep) {
            this.$swal(
               "Appointment Types Must Match",
               "You cannot mix Representative and Non-Representative appointment links in the same multi-link invitation. These must be sent in separate invitations.",
               "warning"
            );
            failed = true
            return
         }

         if(linx != null && linx.length > 0)
         {
            var linkAgentNumber = linx[0].linkRec.recruiterAgentNumber

            //check if the agentnumber from one of the links in the cart
            //is not apart of the current heierarchy agent list
            if(!this.agentNumbers.includes(linkAgentNumber))
            {   
               await this.$swal(
                  "Schedules from Multiple Recruiters",
                  "Please contact Marketing if you need to create appointment links with schedules from different Agent numbers",
                  "warning"
               ); 
               failed = true
            }
         }

         if (!failed) {
            this.cartIsRep = isRep
            cartItem.isRep = isRep

            // If base type is null, there are no siblings
            if (baseTypeId == null) {

               this.$store.commit("addToCart", cartItem)
               this.cartCount = this.$store.getters.cartCount
               let pos = this.getElementOffset(ele)
               let t = document.getElementById('divToast')
               t.style.top = (pos.top - 100) + 'px'
               t.style.left = pos.left + 'px'
               this.cartAddCount = 1
               $('.toast').toast('show');

            } else {

               await this.loadSiblingSchedules(cartItem, ele, baseTypeId)

            }
         }
      },
      async loadSiblingSchedules(item, ele, baseTypeId) {
         let payload = {
            baseScheduleTypeId: baseTypeId,
            marketingDirectorId: this.marketingDirectorId,
            appointmentLinkId: item.linkRec.appointmentLinkId
         }
         await this.$appoint.getCartLinks(payload)
            .then((resp) => {
               this.cartAddCount = 0
               resp.links.forEach((ii) => {
                  let sked = ii.schedule
                  let hdr = ii.header
                  ii.linkRecs.forEach((lr) => {
                     let cartItem = JSON.parse(JSON.stringify(lr))
                     cartItem.scheduleId = sked.scheduleId
                     cartItem.carrierId = sked.carrierId
                     cartItem.carrierCode = sked.carrierCode
                     cartItem.mgaCode = sked.mgaCode
                     cartItem.productTypeId = hdr.productTypeId
                     cartItem.productType = hdr.productType
                     cartItem.isRep = item.isRep

                     this.$store.commit("addToCart", cartItem)
                     this.cartAddCount += 1
                  })
               })
               this.cartCount = this.$store.getters.cartCount
               let pos = this.getElementOffset(ele)
               let t = document.getElementById('divToast')
               t.style.top = (pos.top - 100) + 'px'
               t.style.left = pos.left + 'px'
               $('.toast').toast('show');
            })
            .catch((err) => {
               // log err
            })
      },
      clear() {
         this.$store.commit("clearCart")
         this.cartCount = this.$store.getters.cartCount
      },
      getElementOffset(element) {
         let de = document.documentElement
         let box = element.getBoundingClientRect()
         let top = box.top + window.pageYOffset - de.clientTop
         let left = box.left + window.pageXOffset - de.clientLeft
         return { top: top, left: left }
      },
      async hierarchyChanged(hier) {
         this.$parent.loadingStart()
         this.loading = true;

         this.selectedHierarchy = hier
         this.s.agentNo = this.selectedHierarchy.agentNo
         this.s.companyNo = this.selectedHierarchy.companyNo
         this.s.blockNo = this.selectedHierarchy.blockNo

         this.schedules = []
         await this.loadLinks()
         this.loading = false;
         this.$parent.loadingEnd()
      },
      async loadLinks() {
         var payload = null
         if (this.isLoginUserAsRecruiter) {
            //Login User as recruiter
            if (this.selectedHierarchy == null) return;
            let s = this.selectedHierarchy
            payload = {
               agentNumber: s.agentNo,
               companyNumber: s.companyNo ? s.companyNo.toString() : "0",
               blockNumber: s.blockNo ? s.blockNo.toString() : "0",
               CreateIfMissing: true
            }
         } else {
            //Agent info was passed in from Hierarchy Tree through route parameters.  
            payload = {
               agentNumber: this.s.agentNo,
               companyNumber: this.s.companyNo.toString(),
               blockNumber: this.s.blockNo.toString(),
               CreateIfMissing: true
            }
         }

         await this.$appoint.getLinksByAgent(payload)
            .then((r) => {
               if (!r || r.schedules == null || r.schedules.length < 1) {
                  this.$swal(
                     "Links Not Found",
                     "No enabled links were found for your current hierarchy. If you think you've reached this impass in error, please contact "+process.env.VUE_APP_MKT_EMAIL+".",
                     "warning"
                  );
                  return;
               }
               this.schedules = this.consolodate(r.schedules)
               this.recruiter = r.schedules[0].recruiter
               this.requester = payload
               this.marketingDirectorId = r.marketingDirectorId

               // initialize multi detail tracker for each schedule
               this.schedules.forEach((s) => {
                  this.scheds[s.scheduleId] = null
               })
            })
            .catch((err) => {
               // log err
            })
      },
      consolodate(srcLinks) {
         let result = []
         let typs = []
         srcLinks.forEach((itm, indx) => {
            if (itm.header.isBase) {
               if (!typs.includes(itm.header.schedHeaderId)) {
                  typs.push(itm.header.schedHeaderId)
                  result.push(itm)
               }
            } else {
               result.push(itm)
            }
         })
         return result
      }
   }
}
</script>

<style scoped lang="scss">
@import '../assets/css/colors.scss';

table {
   margin: 0;
   font-size: smaller;
}

.fa-spinner {
   margin: 36px;
}

ul.instr {
   margin-bottom: 36px;
}

.instr li {
   margin: 12px 0;
}

.custom-control-label {
   cursor: pointer;
}

.custom-control-input:checked~.custom-control-label::before {
   background-color: $corp-color;
   border-color: #000;
}

button span {
   margin-left: 6px;
}

.btn-add {
   font-size: larger;
   margin: 0;
   padding: 0;
}

.btnw {
   width: 100px;
}

.toast {
   background-color: $corp-color;
   color: #fff;
}

.toast-header {
   background-color: #000;
   color: #fff;
}

ul.link-list {
   list-style: none;
   font-size: smaller;
}

.doc-link,
.doc-link:hover {
   font-weight: normal;
}

.recruiter-box {
   color: $corp-purple;
   padding-left: 24px;
   font-size: smaller;
}</style>